import { createStore } from 'vuex';

const USER_KEY = 'user_profile';
const USERNAME_KEY = 'username';
const BYBIT_CONNECTION_KEY = 'bybit_connection';

const loadUserFromStorage = () => {
  if (typeof localStorage === 'undefined') return null;

  const raw = localStorage.getItem(USER_KEY);
  if (raw) {
    try {
      return JSON.parse(raw);
    } catch (err) {
      return null;
    }
  }

  const fallbackName = localStorage.getItem(USERNAME_KEY);
  if (fallbackName) {
    return { user_name: fallbackName };
  }

  return null;
};

const sanitizeUserForStorage = (user) => {
  if (!user || typeof user !== 'object') return user;
  return { ...user };
};

const persistUser = (user) => {
  if (typeof localStorage === 'undefined') return;

  if (!user) {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(USERNAME_KEY);
    return;
  }

  const safeUser = sanitizeUserForStorage(user);
  const name = safeUser.user_name || safeUser.username || safeUser.name;
  if (name) {
    localStorage.setItem(USERNAME_KEY, name);
  }
  localStorage.setItem(USER_KEY, JSON.stringify(safeUser));
};

const loadBybitConnectionFromStorage = () => {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(BYBIT_CONNECTION_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (err) {
    return null;
  }
};

const persistBybitConnection = (conn) => {
  if (typeof localStorage === 'undefined') return;
  if (!conn) {
    localStorage.removeItem(BYBIT_CONNECTION_KEY);
    return;
  }
  localStorage.setItem(BYBIT_CONNECTION_KEY, JSON.stringify(conn));
};

export default createStore({
  state() {
    return {
      user: loadUserFromStorage(),
      bybitConnection: loadBybitConnectionFromStorage(),
    };
  },
  getters: {
    username(state) {
      const user = state.user || {};
      return (
        user.user_name ||
        user.username ||
        user.name ||
        'user_0x4f2a'
      );
    },
    bybitConnection(state) {
      return state.bybitConnection;
    },
    walletConnected(state) {
      return !!state.bybitConnection;
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setBybitConnection(state, conn) {
      state.bybitConnection = conn;
    },
  },
  actions: {
    hydrateFromStorage({ commit }) {
      commit('setUser', loadUserFromStorage());
      commit('setBybitConnection', loadBybitConnectionFromStorage());
    },
    setUser({ commit }, user) {
      commit('setUser', user);
      persistUser(user);
    },
    setUsername({ dispatch, state }, username) {
      const nextUser = { ...(state.user || {}), user_name: username };
      dispatch('setUser', nextUser);
    },
    clearUser({ commit }) {
      commit('setUser', null);
      persistUser(null);
    },
    setBybitConnection({ commit }, conn) {
      commit('setBybitConnection', conn);
      persistBybitConnection(conn);
    },
    clearBybitConnection({ commit }) {
      commit('setBybitConnection', null);
      persistBybitConnection(null);
    },
  },
});
